import React from 'react'
import { FaExclamationTriangle } from 'react-icons/fa'

function NotAllowedModule() {
  return (
    <section>
      <div style={{ display: 'flex', direction: 'row', alignItems: 'center' }}>
        <FaExclamationTriangle size={30} color="orange" />
        <h1>Você não tem acesso a este módulo</h1>
      </div>

      <p>Ficou interessado entre em contato:</p>
      <p>
        Email:{' '}
        <a
          href="mailto:victor.hugo@tpmanager.net?subject=Acesso Módulos TpManger&body=Olá, gostaria de ter acesso a mais módulos do TpManager"
          target="_blank"
          rel="noopener noreferrer"
        >
          victor.hugo@tpmanager.net
        </a>
      </p>
      <p>
        Whatsapp:{' '}
        <a
          href="https://wa.me/5518991367506?text=Gostaria%20de%20ter%20acesso%20a%20mais%20módulos%20do%20TpManager"
          target="_blank"
          rel="noopener noreferrer"
        >
          +55 18 99136-7506
        </a>
      </p>
      <p>Atendimento em horário comercial: 9h às 18h</p>
    </section>
  )
}

export default NotAllowedModule
